import { ActionContext } from 'vuex';
import { AdventuresState, AdventureDraft } from './types';

type AdventuresActionContext = ActionContext<AdventuresState, any>;

const actions = {
  updateStore({ commit }: AdventuresActionContext, payload: Partial<AdventureDraft>) {
    commit('setAdventureDraft', payload);
  },

  updatePending({ commit }: AdventuresActionContext, payload: Partial<AdventureDraft>) {
    commit('setPendingEdits', payload);
  },

  flashMessage({ commit }: AdventuresActionContext, payload: string | undefined) {
    commit('setFlashMessage', payload);
  },

  resetStore({ commit }: AdventuresActionContext) {
    commit('resetAdventureStore');
  },
};

export default actions;
